import React, { useState } from 'react';
import moment from 'moment';
import ReactGA from 'react-ga4';

import Greeting from '../partials/blocks/greeting';
import CTAButton from '../partials/components/ctaButton';

import { useRootContext } from '../partials/context/rootContext';

const EventRsvp = ({ ...props }) => {
    const { setRsvpContext, setRegisterContext } = useRootContext();

    const postRSVP = value => {
        
        //Analytics
        ReactGA.event({
            category: "GA Event - " + props.data.event.main_event_name,
            action: "RSVP - " + (value ? 'Yes' : 'No'),
        });

        fetch(`${launchframe.ajax_url}?action=register_for_event&event_id=${props.data.current_event}&rsvp=${value}`, {
            method: 'POST'
        })
            .then(res => res.json())
            .then(
                result => {
                    setRegisterContext(true);
                    setRsvpContext(value);
                    window.location.reload(false);
                },

                error => {}
            );
    };

    const parseDescription = desc => {
        let splitDesc = desc;

        return splitDesc;
    };

    if(! props.data.display_rsvp) {
        return null;
    }

    const root_url = `${location.protocol}//${location.host}`;

    return (
        <section className="flex relative w-full items-center justify-center bg-white">
            <div className="flex relative flex-col lg:flex-row container px-4 lg:px-20 pt-4 lg:pt-24">
                <div className="relative flex w-full lg:w-1/2 flex-col">
                    <div className="relative flex ">
                        <Greeting 
                            firstName={props.data.attendee.first_name}
                            location={props.data.event.location_below_greeting ? props.data.attendee.location : 'Non-Regional'}
                        />
                    </div>
                    <div className="pr-10 text-2xl lg:text-3xl font-sans justify-center font-bold leading-snug">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: props.data.rsvp_info.rsvp_description
                                    .split('%%date%%')
                                    .join(
                                        `<span class="text-red-500">${moment(props.data.event.start).format(
                                            'MMMM Do, YYYY'
                                        )}</span>`
                                    )
                            }}
                        /><br/>
                        <div className="text-2xl">To invite your Leaders, please have them visit {root_url} to RSVP!</div>
                        <br /> <div className="mt-4">Will you join us?</div>
                        <div className="flex flex-row space-x-4 mt-4">
                            <CTAButton
                                text="RSVP Yes"
                                onButtonClick={() => {
                                    postRSVP(true);
                                }}
                            />
                            <CTAButton
                                text="RSVP No"
                                onButtonClick={() => {
                                    postRSVP(false);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="relative hidden lg:flex w-full lg:w-1/2 justify-center items-center">
                    <img style={{ height: 360 }} src={props.data.rsvp_info.rsvp_image.url} alt="RSVP Logo" />
                </div>
            </div>
        </section>
    );
};

export default EventRsvp;
